import { useRef } from 'react';
import { Icon } from '../../Atoms/Icon';
import { TextSpan } from '../../Atoms/Text';
import { AttachmentCTAProps } from './AttachmentCTA';

export interface AttachmentTableCTAProps extends AttachmentCTAProps {
  label?: string;
}

export function AttachmentTableCTA({ addAttachments, label = 'New Attachment' }: AttachmentTableCTAProps) {
  const addAttachmentRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <TextSpan className="flex items-center space-x-2">
        <Icon type="plus" />
        <button
          className="text-grey-12 text-sm"
          data-cy="new-attachment"
          type="button"
          onClick={() => addAttachmentRef.current?.click()}>
          {label}
        </button>
        <input
          hidden
          ref={addAttachmentRef}
          type="file"
          multiple={true}
          data-testid="attachment-input"
          onChange={(e) => {
            addAttachments(Array.from(e.target.files as FileList));
            // Re-picking the same file fires no change event unless the input forgets it.
            e.target.value = '';
          }}
        />
      </TextSpan>
    </>
  );
}
